exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mw-900[data-v-11ed547b] {\n  min-width: 40rem;\n}\n", ""]);

// exports
